import Container from './CommentBoxEditor.container';
import CommentBoxEditor from './CommentBoxEditor';
// We don't do feature branching here because
// CommentBoxEditor is used with ref and `withFeatureFlags` doesn't
// support forwarding refs.
export default Container(CommentBoxEditor);
//# sourceMappingURL=index.js.map